export type ExportTemplate = 'minimal' | 'business' | 'warm';
export type ExportFormat = 'pdf' | 'png';

export interface ExportSections {
  customerInfo: boolean;
  schedule: boolean;
  orderItems: boolean;
  payment: boolean;
  specialInstructions: boolean;
}

export interface ExportCustomInfo {
  companyName: string;
  tagline: string;
  footerNote: string;
}

export interface ExportConfig {
  template: ExportTemplate;
  sections: ExportSections;
  customInfo: ExportCustomInfo;
  format: ExportFormat;
  showWatermark: boolean;
}

export const DEFAULT_EXPORT_CONFIG: ExportConfig = {
  template: 'minimal',
  sections: {
    customerInfo: true,
    schedule: true,
    orderItems: true,
    payment: true,
    specialInstructions: true,
  },
  customInfo: {
    companyName: '',
    tagline: '',
    footerNote: '',
  },
  format: 'pdf',
  showWatermark: false,
};

export const TEMPLATE_LABELS: Record<ExportTemplate, string> = {
  minimal: '简约白',
  business: '商务深',
  warm: '暖色调',
};
